<template>
  <app-page :head="data.head" :body="data.body" />
</template>

<script setup>
const { params } = useRoute();
const { data } = await useFetch(`/api/page_engineering?lng=${params.locale}`);
</script>
